namespace advisorop.components.servicer {

    export class DocusignIntegrationRequestController {

        static $inject = ["generalService", "servicerService"];
        constructor(private generalService: services.GeneralService,
            private servicerService: services.ServicerService) {
        }

        docuSignLinkRequest(): void {
            this.servicerService.docusignIntegrationCheck()
                .then(data => {
                    var proceed: Boolean = true;
                    if (data.data == "ALREADY_LINKED") {
                        proceed = confirm(`It looks like your account is already linked. Link again?`);
                    }
                    if (proceed) {
                        this.servicerService.docusignIntegrationRequest()
                            .then(data => {
                                window.open(data.data, "_blank");
                            })
                            .catch(err => { this.generalService.showError(err); });
                    } else {
                        toastr.warning("You have decided not to link at this time.");
                    }
                })
                .catch(err => { toastr.error("Error."); });
        }

        $onInit(): void {

        };

        $onChanges(evt): void {
        }

    }

    class DocusignIntegrationRequest implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "router": "<",
            };
            this.controller = DocusignIntegrationRequestController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/docusign-integration-request.html';
        }
    }
    angular.module(Constants.APP).component("docusignIntegrationRequest", new DocusignIntegrationRequest());
}